// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDialog } from 'ui-components';

export const StyledSaveSubjectsDialog = styled(UiDialog)(
  () => css`
    &.save-subjects-modal {
      .card-body {
        padding: 20px 20px !important;
      }

      .subjects-button {
        width: 48px !important;
        height: 48px !important;
      }
    }
  `
);
